import { css } from "styled-components";

export const ContentRowStyles = css`
  margin-top: 15px;
  margin-bottom: 15px;

  .content-row__empty {
    padding-top: 16px;
    padding-bottom: 16px;
  }
`;

// export const FilterRowStyles = css`
//   .searchDirectory__filter-row {
//     /* padding: 6.5px 11px; */
//     /* border-bottom: 1px solid lightgrey; */
//     padding: 8px 16px;
//     border-bottom: 1px solid #e8e8e8;
//     /* box-shadow: 0px 0px 4px 0px #ccc; */

//     /*  */
//     .ant-radio-button-wrapper:not(:last-child) {
//       margin-right: 5px;
//     }

//     /*  */
//     .ant-radio-button-wrapper {
//       font-size: 13px;
//       border: none;
//       border-radius: 5px;
//       background-color: #f0f0f0;
//       font-weight: 600;

//       .filter-row__btn-title {
//         display: flex;
//         align-items: center;
//       }

//       &.ant-radio-button-wrapper-checked {
//         color: white;
//         background: #1890ff; /* blue-6*/
//         font-weight: 800;
//       }

//       /* not disabled and not checked (normal button) */
//       :not(&.ant-radio-button-wrapper-checked):not(.ant-radio-button-wrapper-disabled) {
//         :hover,
//         :active,
//         :focus {
//           background: #d9d9d9; /* grey-5*/
//           color: black;
//         }
//       }

//       /* hide the vertical line separator of radio group */
//       ::before {
//         content: none;
//       }

//       .filter-row__badge-counter {
//         margin-left: 4px;
//         .ant-badge-count {
//           box-shadow: none;
//         }
//         &.selected > .ant-badge-count {
//           font-weight: 800;
//         }
//       }

//     }

//     /*  */
//   }
// `;
